module.exports = __webpack_public_path__ + "static/media/barChart.8d565964.svg";